module.exports = __webpack_public_path__ + "cce422c2c30dc2f3427caad099ed46d7.glb";